// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as CrmUtils from "../../../../../../../library/CrmUtils.bs.js";
import * as Currency from "../../../../../../../library/data-source/country-currency/Currency.bs.js";
import * as Formality from "../../../../../../../../node_modules/re-formality/src/Formality.bs.js";
import * as Belt_Float from "../../../../../../../../node_modules/rescript/lib/es6/belt_Float.js";
import * as Belt_Option from "../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Belt_Result from "../../../../../../../../node_modules/rescript/lib/es6/belt_Result.js";
import * as Caml_option from "../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Formality__ReactUpdate from "../../../../../../../../node_modules/re-formality/src/Formality__ReactUpdate.bs.js";
import * as PrimitiveFormTypes$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/PrimitiveFormTypes.bs.js";

function isActualPartnerCollectedCashEnabled(orderStatue, order) {
  if (CrmUtils.isPfeOrder(order)) {
    return false;
  } else {
    return orderStatue === 7 || orderStatue === 6;
  }
}

function getActualPartnerCollectedCashValue(fareDetails) {
  var customerFare = fareDetails.customer;
  if (customerFare !== undefined) {
    return Currency.toString(customerFare.payment.driver_collected_cash);
  }
  
}

var validators_actualPartnerCollectedCash = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param, metadata) {
      var actualPartnerCollectedCash = param.actualPartnerCollectedCash;
      if (isActualPartnerCollectedCashEnabled(metadata.orderStatus, metadata.order) && metadata.isFormActive) {
        if (actualPartnerCollectedCash !== undefined) {
          return Belt_Result.flatMap(PrimitiveFormTypes$Catalyst.getValue({
                          TAG: /* Float */3,
                          _0: actualPartnerCollectedCash
                        }), (function (collectedCash) {
                        if (collectedCash < 0.0) {
                          return {
                                  TAG: /* Error */1,
                                  _0: "Partner collected cash cannot be in negative"
                                };
                        } else {
                          return {
                                  TAG: /* Ok */0,
                                  _0: Caml_option.some(Currency.toCurrency(collectedCash))
                                };
                        }
                      }));
        } else {
          return {
                  TAG: /* Error */1,
                  _0: "Actual partner collected cash cannot be empty"
                };
        }
      } else {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      }
    })
};

var validators = {
  actualPartnerCollectedCash: validators_actualPartnerCollectedCash,
  totalAmountPaid: undefined
};

function initialFieldsStatuses(_input) {
  return {
          actualPartnerCollectedCash: /* Pristine */0,
          totalAmountPaid: /* Pristine */0
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: {
            actualPartnerCollectedCash: /* Pristine */0,
            totalAmountPaid: /* Pristine */0
          },
          collectionsStatuses: undefined,
          formStatus: /* Editing */0,
          submissionStatus: /* NeverSubmitted */0
        };
}

function validateForm(input, validators, fieldsStatuses, metadata) {
  var match = fieldsStatuses.actualPartnerCollectedCash;
  var match_0 = match ? match._0 : Curry._2(validators.actualPartnerCollectedCash.validate, input, metadata);
  var match_0$1 = {
    TAG: /* Ok */0,
    _0: input.totalAmountPaid
  };
  var actualPartnerCollectedCashResult = match_0;
  var actualPartnerCollectedCashResult$1;
  if (actualPartnerCollectedCashResult.TAG === /* Ok */0) {
    var totalAmountPaidResult = match_0$1;
    if (totalAmountPaidResult.TAG === /* Ok */0) {
      return {
              TAG: /* Valid */0,
              output: {
                totalAmountPaid: totalAmountPaidResult._0,
                actualPartnerCollectedCash: actualPartnerCollectedCashResult._0
              },
              fieldsStatuses: {
                actualPartnerCollectedCash: /* Dirty */{
                  _0: actualPartnerCollectedCashResult,
                  _1: /* Shown */0
                },
                totalAmountPaid: /* Dirty */{
                  _0: totalAmountPaidResult,
                  _1: /* Hidden */1
                }
              },
              collectionsStatuses: undefined
            };
    }
    actualPartnerCollectedCashResult$1 = actualPartnerCollectedCashResult;
  } else {
    actualPartnerCollectedCashResult$1 = actualPartnerCollectedCashResult;
  }
  return {
          TAG: /* Invalid */1,
          fieldsStatuses: {
            actualPartnerCollectedCash: /* Dirty */{
              _0: actualPartnerCollectedCashResult$1,
              _1: /* Shown */0
            },
            totalAmountPaid: /* Dirty */{
              _0: match_0$1,
              _1: /* Hidden */1
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, metadata, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action === "number") {
            switch (action) {
              case /* BlurActualPartnerCollectedCashField */0 :
                  var result = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.actualPartnerCollectedCash, validators_actualPartnerCollectedCash, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  actualPartnerCollectedCash: status,
                                  totalAmountPaid: init.totalAmountPaid
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurTotalAmountPaidField */1 :
                  var result$1 = Formality.validateFieldOnBlurWithoutValidator(state.input.totalAmountPaid, state.fieldsStatuses.totalAmountPaid, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  actualPartnerCollectedCash: init.actualPartnerCollectedCash,
                                  totalAmountPaid: status
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* Submit */2 :
                  var match = state.formStatus;
                  if (typeof match !== "number" && match.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses, metadata);
                  if (match$1.TAG !== /* Valid */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: /* AttemptedToSubmit */1
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error === "number" || error.TAG !== /* SubmissionFailed */1 ? undefined : Caml_option.some(error._0);
                  return {
                          TAG: /* UpdateWithSideEffects */1,
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: /* Submitting */0,
                              _0: tmp
                            },
                            submissionStatus: /* AttemptedToSubmit */1
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              return Curry._2(onSubmit, output, {
                                          notifyOnSuccess: (function (input) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmittedStatus */2,
                                                          _0: input
                                                        });
                                            }),
                                          notifyOnFailure: (function (error) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmissionFailedStatus */3,
                                                          _0: error
                                                        });
                                            }),
                                          reset: (function (param) {
                                              return Curry._1(dispatch, /* Reset */5);
                                            }),
                                          dismissSubmissionResult: (function (param) {
                                              return Curry._1(dispatch, /* DismissSubmissionResult */4);
                                            })
                                        });
                            })
                        };
                  break;
              case /* DismissSubmissionError */3 :
                  var match$2 = state.formStatus;
                  if (typeof match$2 === "number" || match$2.TAG !== /* SubmissionFailed */1) {
                    return /* NoUpdate */0;
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* DismissSubmissionResult */4 :
                  var match$3 = state.formStatus;
                  if (typeof match$3 === "number") {
                    if (match$3 === /* Editing */0) {
                      return /* NoUpdate */0;
                    }
                    
                  } else if (match$3.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: /* Editing */0,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* Reset */5 :
                  return {
                          TAG: /* Update */0,
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG | 0) {
              case /* UpdateActualPartnerCollectedCashField */0 :
                  var nextInput = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput, metadata, state.fieldsStatuses.actualPartnerCollectedCash, state.submissionStatus, validators_actualPartnerCollectedCash, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            actualPartnerCollectedCash: status,
                                            totalAmountPaid: init.totalAmountPaid
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateTotalAmountPaidField */1 :
                  var nextInput$1 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$1.totalAmountPaid, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            actualPartnerCollectedCash: init.actualPartnerCollectedCash,
                                            totalAmountPaid: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* SetSubmittedStatus */2 :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: input,
                              fieldsStatuses: {
                                actualPartnerCollectedCash: /* Pristine */0,
                                totalAmountPaid: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: {
                                actualPartnerCollectedCash: /* Pristine */0,
                                totalAmountPaid: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* SetSubmissionFailedStatus */3 :
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: /* SubmissionFailed */1,
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* MapSubmissionError */4 :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 === "number") {
                    return /* NoUpdate */0;
                  }
                  if (error$1.TAG !== /* Submitting */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* SubmissionFailed */1,
                                _0: Curry._1(map, error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* Submitting */0,
                                _0: Caml_option.some(Curry._1(map, Caml_option.valFromOption(error$2)))
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 === "number" || match$1.TAG !== /* Submitting */0 ? false : true;
  return {
          updateActualPartnerCollectedCash: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateActualPartnerCollectedCashField */0,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateTotalAmountPaid: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateTotalAmountPaidField */1,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          blurActualPartnerCollectedCash: (function (param) {
              return Curry._1(dispatch, /* BlurActualPartnerCollectedCashField */0);
            }),
          blurTotalAmountPaid: (function (param) {
              return Curry._1(dispatch, /* BlurTotalAmountPaidField */1);
            }),
          actualPartnerCollectedCashResult: Formality.exposeFieldResult(state.fieldsStatuses.actualPartnerCollectedCash),
          totalAmountPaidResult: Formality.exposeFieldResult(state.fieldsStatuses.totalAmountPaid),
          input: state.input,
          status: state.formStatus,
          dirty: (function (param) {
              var match = state.fieldsStatuses;
              if (match.actualPartnerCollectedCash || match.totalAmountPaid) {
                return true;
              } else {
                return false;
              }
            }),
          valid: (function (param) {
              var match = validateForm(state.input, validators, state.fieldsStatuses, metadata);
              if (match.TAG === /* Valid */0) {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function (param) {
              return Curry._1(dispatch, /* Submit */2);
            }),
          dismissSubmissionError: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionError */3);
            }),
          dismissSubmissionResult: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionResult */4);
            }),
          mapSubmissionError: (function (map) {
              return Curry._1(dispatch, {
                          TAG: /* MapSubmissionError */4,
                          _0: map
                        });
            }),
          reset: (function (param) {
              return Curry._1(dispatch, /* Reset */5);
            })
        };
}

var ActualPartnerCollectedCashForm = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

function getInitialInput(fareDetails) {
  if (fareDetails === undefined) {
    return {
            totalAmountPaid: undefined,
            actualPartnerCollectedCash: undefined
          };
  }
  var customer = fareDetails.customer;
  return {
          totalAmountPaid: customer !== undefined ? customer.fare.fare_with_dues : Caml_option.some(fareDetails.estimated.trip_fare),
          actualPartnerCollectedCash: getActualPartnerCollectedCashValue(fareDetails)
        };
}

function getPayload(formData, crn, order_updated_at) {
  if (formData === undefined) {
    return ;
  }
  var data = formData.actualPartnerCollectedCash;
  return {
          crn: crn,
          actual_partner_collected_cash: data !== undefined ? Belt_Option.getWithDefault(Belt_Float.fromString(Currency.toString(Caml_option.valFromOption(data))), 0.0) : 0.0,
          order_updated_at: order_updated_at
        };
}

var ActualPartnerCollectedCashHelper = {
  getInitialInput: getInitialInput,
  getPayload: getPayload
};

export {
  isActualPartnerCollectedCashEnabled ,
  getActualPartnerCollectedCashValue ,
  ActualPartnerCollectedCashForm ,
  ActualPartnerCollectedCashHelper ,
  
}
/* react Not a pure module */
